module.exports = __webpack_public_path__ + "14_hair_black.3c47f453.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/14_hair_black.png
// module id = 61zg
// module chunks = 0